import { DashboardView } from "~/modules/dashboard/components/DashboardView.tsx";

export function DashboardPage() {
	return <DashboardView />;
}
